import React, { useEffect, useState } from 'react'
import { Row, Col, Button, Modal, Form } from 'react-bootstrap';
import { getItem, setItem } from '../../config/localStorage';
import { pythonAxiosInstance } from '../../config/ConfigInfo';

function LanguagesModal(props) {

    const getLanguageData = getItem('languagesData') ? JSON.parse(getItem('languagesData')) : '';

    const [language, setlangugae] = useState(getLanguageData ? getLanguageData : [{ languageTitle: '', languageType: '' }]);
    const [languageList, setLangugaeList] = useState([]);
    const [levelsList, setLevelsList] = useState([]);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [showAddBtn, setShowAddBtn] = useState((getLanguageData ? true : false))
    const {setPersonalCheckbox,...rest} = props
    useEffect(() => {
        (async () => {
            try {
                const response = await pythonAxiosInstance.post('provide-language-level/');
                if (response.status === 200) {
                    setLangugaeList(response?.data?.languages);
                    setLevelsList(response?.data?.levels);
                }
            } catch (error) {
                setError(error.message);
            }
        })()
    }, [])

    const handleAddField = () => {
        const newLanguage = [...language, { languageTitle: '', languageType: '' }];

        setShowAddBtn(false)
        setlangugae(newLanguage);
        setSuccess('')
        setError('')
    };

    const handleRemoveField = (index) => {
        const newLanguage = [...language];
        newLanguage.splice(index, 1);
        setlangugae(newLanguage);
        setSuccess('')
        setError('')

        let isValid = newLanguage.every((each) => each.languageTitle !== "")
        setShowAddBtn(isValid)
    };

    const handleChange = (index, event) => {
        const { name, value } = event.target;
        const newLanguage = [...language];
        newLanguage[index][name] = value;

        let isValid = newLanguage.every((each) => each.languageTitle !== "")

        const langugaeTitles = newLanguage.map(item => item.languageTitle);
        const uniqueLanguageTitles = new Set(langugaeTitles);
        const hasDuplicateLangugaeTitle =  langugaeTitles.length !== uniqueLanguageTitles.size;

        if(!hasDuplicateLangugaeTitle && isValid ){
            setShowAddBtn(isValid)
            setError('')
        }else{
            setShowAddBtn(false)
            if(value !== '' && name === 'languageTitle'){
                setError('You have selected same language!')
            }
        }

        setlangugae(newLanguage);
        setSuccess('')
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (language[0]['languageTitle'] === '' ) {
            setSuccess('')
            setError('First field is required!');
        } else {
            setError('');
            setSuccess('Thank you for providing your language details.');
            setItem('languagesData', JSON.stringify(language));
        }
        
        setPersonalCheckbox((prev)=> !prev)
  
    };

    const closePopUp = () => {
        setPersonalCheckbox((prev)=> !prev)
        setSuccess('')
        setError('')
    };

    return (
        <>
            <Modal
                {...rest}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop='static'
            >
                <Modal.Header closeButton onClick={closePopUp}>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Languages
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        {
                            language.map((field, index) => (
                                <Row key={index} className='lang-outer mb-3 responsive-language-section'>

                                    <Col md={6} className='responsive-language-item'>
                                        <Form.Group>
                                            <Form.Label>Language <span className="fa fa-star requierd-star"></span></Form.Label>
                                            <Form.Select name="languageTitle" onChange={(event) => handleChange(index, event)} value={field.languageTitle ?? '' }> 
                                                <option value=''>Select</option>
                                                {
                                                    languageList.map((field, index) => (
                                                        <option value={field} key={index}>{field}</option>
                                                    ))
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={5} className='responsive-language-item'>
                                        <Form.Group >
                                            <Form.Label>Level</Form.Label>
                                            <Form.Select name="languageType" onChange={(event) => handleChange(index, event)} value={field.languageType}>
                                                <option value=''>Select</option>
                                                {
                                                    levelsList.map((field, index) => (
                                                        <option value={field} key={index}>{field}</option>
                                                    ))
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    {language.length > 1 && (

                                        <Col md={1} className='responsive-language-item'>
                                            <Button className='btn btn-danger' onClick={() => handleRemoveField(index)}><i className="fa fa-trash"></i></Button>
                                        </Col>
                                    )}

                                </Row>
                            ))
                        }

                        {/* {
                            languageList.length <= language.length ? "as" : 'bb'
                        } */}


                        <Col md={12} className='text-end mb-3'>
                            <Button className="text-end text-success btn finalize-btn" disabled={!showAddBtn} onClick={handleAddField}><i className='fa fa-plus'></i> Add one more</Button>
                        </Col>

                        {
                            error ? <div className="alert alert-danger mt-3" role="alert">{error}</div> : ''
                        }

                        {
                            success ? <div className="alert alert-success mt-3" role="alert">{success}</div> : ''
                        }


                        <Modal.Footer>
                            <Button className='button-green' type="submit" disabled={!showAddBtn} onClick={handleSubmit}>Save changes</Button>
                        </Modal.Footer>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default LanguagesModal
